import type { SVGProps } from 'react';
const SvgFiberManualRecord = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fiber_manual_record_svg__a)">
      <path fill="currentColor" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z" />
    </g>
    <defs>
      <clipPath id="fiber_manual_record_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiberManualRecord;
